import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="itineraries"
export default class extends Controller {
  
  update(e) {
    const input = e.target
    const initialValue = parseFloat(input.dataset.initial, 10)
    const currentValue = parseFloat(input.value, 10)
    const changed = !isNaN(currentValue) && currentValue !== initialValue
    const button = input.nextElementSibling
    if (changed) {
      button.innerHTML = `<i class="fal fa-check"></i>`
      button.disabled = false
    } else {
      button.textContent = "km"
      button.disabled = true
    }
  }

}
